import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Admins from '../admins/Admins';
import AdminPage from '../admin/Admin';
import { withLocalize, Translate } from "react-localize-redux";
var adminTranslations = require("../../translations/admin.json")


class AdminsRouter extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.props.addTranslation(adminTranslations)

  }
  componentWillMount() {
    //Only admins can see this page
    if(window.account.type != "admin")
      this.props.history.push("/login/admin")
  }
  public render() {
    return (
      <div id="admins-router-root">
        <div className="buttonsHeader">
          {window.account.privilege == "admin" && <Link to="/admins/new"><button><Translate id="admin.newAdmin" /></button></Link>}
        </div>

        <Switch>
          <Route exact path={`/admins`} component={Admins} />
          <Route exact path={`/admins/new`} component={AdminPage} />
          <Route exact path={`/admins/:id`} component={AdminPage} />
        </Switch>

      </div>
    );
  }
}

export default withLocalize(AdminsRouter)



// WEBPACK FOOTER //
// ./src/pages/home/AdminsRouter.tsx